import { render, staticRenderFns } from "./ViewInvitation.vue?vue&type=template&id=0955f366&scoped=true"
import script from "./ViewInvitation.vue?vue&type=script&lang=js"
export * from "./ViewInvitation.vue?vue&type=script&lang=js"
import style0 from "./ViewInvitation.vue?vue&type=style&index=0&id=0955f366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0955f366",
  null
  
)

export default component.exports